import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-success",
  "use": "icon-success-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-success\"><defs><style type=\"text/css\"></style></defs><path d=\"M513.6 954.8C269 954.8 70 755.8 70 511.1S269 67.5 513.6 67.5s443.7 199 443.7 443.7-199.1 443.6-443.7 443.6z m0-824.6c-210 0-380.9 170.9-380.9 380.9S303.6 892 513.6 892s380.9-170.9 380.9-380.9-170.9-380.9-380.9-380.9z\" p-id=\"2092\" fill=\"#07c160\" /><path d=\"M272.73 506.1l43.003-40.828 197.393 207.915-43.004 40.828z\" p-id=\"2093\" fill=\"#07c160\" /><path d=\"M746.457 372.476l40.668 43.159-316.52 298.254-40.668-43.159z\" p-id=\"2094\" fill=\"#07c160\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/success.svg
// module id = C5yd
// module chunks = 44